import { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";

import { keys } from "@/features/dashboard/features/widgets/hooks/queries";
import { useDashboardData } from "@/features/shared/hooks";
import { useRefreshAction } from "@/features/dashboard/features/refresh-timer/hooks";

const useRefreshWidget = (widgetId: string | undefined) => {
  const queryClient = useQueryClient();
  const { selectedLocation, selectedDashboard, selectedTimeRange } = useDashboardData();

  const refresh = useCallback(async () => {
    if (!widgetId) return;
    await queryClient.refetchQueries({
      queryKey: keys.publishedWidgetData(
        widgetId,
        selectedDashboard?.id ?? "",
        selectedLocation?.id,
        selectedTimeRange,
      ),
    });
  }, [widgetId, selectedDashboard, selectedLocation, selectedTimeRange]);
  useRefreshAction(refresh);
};

export default useRefreshWidget;
